import React, { useEffect, useState } from "react";
import Table from "../../../Utils/Table/Table1";
import {
  getAdminLogsAPI,
  getUserdata,
  updateActivestatus,
} from "../../../Services/Superadmin/Superadmin";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Pencil, Eye } from "lucide-react";
import Swal from "sweetalert2";
import { fDateTimesec } from "../../../Utils/Date_format/datefromat";
import { Modal, Button } from "react-bootstrap";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { Users, UserCheck, UserX } from "lucide-react";

const Admin = () => {



  const navigate = useNavigate();
  const location = useLocation();
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [getActiveInactive, setActiveInactive] = useState(
    location.state?.status || "all"
  );

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);


  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logsData, setLogsData] = useState([]);

  useEffect(() => {
    getAllAdmin();
  }, [page, rowsPerPage, searchTerm, selectedFilters, getActiveInactive]);

  const handleFilterChange = (e) => {
    const { value, checked } = e.target;
    setSelectedFilters((prevFilters) =>
      checked
        ? [...prevFilters, value]
        : prevFilters.filter((filter) => filter !== value)
    );
  };

  const handleSelectAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setSelectedFilters([
        "EveryTransaction",
        "FixedPerClient",
        "FundAdd",
        "NetTransactionPercent",
      ]);
    } else {
      setSelectedFilters([]);
    }
  };

  const isAllSelected = selectedFilters.length === 4;

  const columns = [
    {
      Header: "S.No",
      id: "rowIndex",
      Cell: ({ index }) => (page - 1) * rowsPerPage + index + 1,
    },

    { Header: "UserName", accessor: "UserName" },
    { Header: "Password", accessor: "Otp" },
    { Header: "Email", accessor: "Email" },
    { Header: "Phone No", accessor: "PhoneNo" },
    {
      Header: "Status",
      accessor: "ActiveStatus",
      Cell: (props) => {
        const row = props?.cell?.row || props?.row || {};
        const value = props?.cell?.value ?? row.ActiveStatus;

        return (
          <label className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={value == 1}
              onChange={(e) => updateactivestatus(e, row?._id)}
            />
          </label>
        );
      },
    },


    {
      Header: "Action",
      accessor: "Action",
      Cell: (props) => {
        const row = props?.cell?.row || props?.row || {};

        return (
          <Pencil
            width={20}
            height={20}
            style={{ cursor: "pointer", color: "#33B469" }}
            onClick={() => updateAdmin(row?._id, row)}
          />
        );
      },
    },


    {
      Header: "User",
      accessor: "Admin_User",
      Cell: (props) => {
        const row = props?.cell?.row || props?.row || {};
        return (
          <Eye
            style={{ cursor: "pointer", color: "#12271aff" }}
            onClick={() => AdminUserdetail(row?._id)}
          />
        );
      },
    },

    {
      Header: "Logs",
      accessor: "logs",
      Cell: (props) => {
        const row = props?.cell?.row || props?.row || {};
        return (
          <Eye
            style={{ cursor: "pointer", color: "#12271aff" }}
            onClick={() => AdminLogs(row?._id)}
          />
        );
      },
    },

    {
      Header: "Employee",
      accessor: "Employee",
      Cell: (props) => {
        const row = props?.cell?.row || props?.row || {};
        return (
          <Eye
            style={{ cursor: "pointer", color: "#12271aff" }}
            onClick={() => AdminEmployeedetail(row?._id)}
          />
        );
      },
    },


    {
      Header: "Create Date",
      accessor: "createdAt",
      Cell: (props) => {
        const value = props?.cell?.value ?? props?.row?.createdAt;
        return value ? fDateTimesec(value) : "";
      },
    },

  ];

  const AdminUserdetail = (_id) => {
    navigate(`adminuser/${_id}`);
  };

  const AdminLogs = async (_id) => {
    const data = { id: _id };
    const response = await getAdminLogsAPI(data);
    setLogsData(response.data || []);
    setLogsModalOpen(true);
  };

  const AdminEmployeedetail = (_id) => {
    navigate(`adminemployee/${_id}`);
  };

  const updateAdmin = (_id, obj) => {
    navigate(`updateadmin/${_id}`, { state: { rowData: obj } });
  };

  const updateactivestatus = async (event, id) => {
    const user_active_status = event.target.checked ? 1 : 0;

    const result = await Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
      allowOutsideClick: false,
    });

    if (result.isConfirmed) {
      try {
        const response = await updateActivestatus({ id, user_active_status });
        if (response.status) {
          Swal.fire({
            title: "Saved!",
            icon: "success",
            timer: 1000,
            timerProgressBar: true,
          });
          setTimeout(() => {
            Swal.close();

            getAllAdmin();
          }, 1000);
        }
      } catch (error) {
        Swal.fire(
          "Error",
          "There was an error processing your request.",
          "error"
        );
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      window.location.reload();
    }
  };
  const getAllAdmin = async () => {
    setLoading(true);


    let ActiveStatus = "";
    if (getActiveInactive === "Active") ActiveStatus = 1;
    else if (getActiveInactive === "Inactive") ActiveStatus = 0;


    const bodyData = {
      id: user_id,
      page: page,
      limit: rowsPerPage,
      search: searchTerm.trim(),
      ActiveStatus: ActiveStatus,
    };

    try {
      const response = await getUserdata(bodyData);


      setTotalPages(response.pagination?.totalPages || 1);


      setData(response.data || []);
    } catch (error) {
      console.error("Admin load error:", error);
    } finally {
      setLoading(false);
    }
  };



  const getHeadingText = () => {
    if (getActiveInactive === "Active")
      return (
        <span className="fw-semibold d-flex align-items-center gap-2">
          <UserCheck size={20} /> Active Admins
        </span>
      );

    if (getActiveInactive === "Inactive")
      return (
        <span className="fw-semibold d-flex align-items-center gap-2">
          <UserX size={20} /> Inactive Admins
        </span>
      );

    return (
      <span className="fw-semibold d-flex  align-items-center gap-2">
        <Users size={20} /> All Admins
      </span>
    );
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);         // Table1 prev/next se ye call karega
  };

  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
  };


  return (
    <>

      <Modal
        show={logsModalOpen}
        onHide={() => setLogsModalOpen(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Admin Logs</Modal.Title>
        </Modal.Header>
        <Modal.Body className="overflow-auto" style={{ maxHeight: "70vh" }}>
          {logsData.length === 0 ? (
            <div className="text-center">No logs found.</div>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-sm"
                style={{ border: "none" }}
              >

                <thead className="table-primary">
                  <tr>
                    <th style={{ color: "black" }}>S.No</th>
                    <th style={{ color: "black" }}>Field</th>
                    <th style={{ color: "black" }}>Old Value</th>
                    <th style={{ color: "black" }}>New Value</th>
                    <th style={{ color: "black" }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {(() => {
                    let serial = 1;
                    const rows = [];
                    logsData.forEach((log) => {
                      if (log.changes && log.changes.length > 0) {
                        log.changes.forEach((change) => {
                          rows.push(
                            <tr key={`${log._id}-${serial}`}>
                              <td>{serial++}</td>
                              <td>{change.field}</td>
                              <td>
                                {change.oldValue === true
                                  ? "Checked"
                                  : change.oldValue === false
                                    ? "Unchecked"
                                    : String(change.oldValue)}
                              </td>
                              <td>
                                {change.newValue === true
                                  ? "Checked"
                                  : change.newValue === false
                                    ? "Unchecked"
                                    : String(change.newValue)}
                              </td>
                              <td>
                                {log.timestamp
                                  ? fDateTimesec(log.timestamp)
                                  : "-"}
                              </td>
                            </tr>
                          );
                        });
                      } else {
                        rows.push(
                          <tr key={`${log._id}-nochange`}>
                            <td>{serial++}</td>
                            <td colSpan={4} className="text-center">
                              No changes
                            </td>
                          </tr>
                        );
                      }
                    });
                    return rows;
                  })()}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setLogsModalOpen(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="container-fluid w-full mt-5">
        <div className="row">
          <div className="col-lg-12">
            <div className="card transaction-table" style={{ background: "#F7F7F7" }}>

              <div className="card-header border-0 py-3 shadow-md d-flex flex-wrap ">
                <div className="mb-2">
                  <h4 className="card-title">{getHeadingText()}</h4>
                </div>
                <Link
                  to="/superadmin/addmin"
                  className="float-end mb-2 btn btn-primary"
                  style={{ display: "inline-flex", alignItems: "center", gap: 8 }}
                >
                  Add Admin
                </Link>
              </div>

              <div className="card-body pt-3">
                <div className="tab-content" id="myTabContent1">
                  <div
                    className="tab-pane fade show active"
                    id="Week"
                    role="tabpanel"
                    aria-labelledby="Week-tab"
                  >
                    <div className="row mb-3 ms-2 pt-3 d-flex justify-content-between">

                      <div className="col-md-3 mb-2">
                        <label
                          htmlFor="searchInput"
                          className="form-label fw-bold"
                        >
                          🔍 Search
                        </label>
                        <input
                          id="searchInput"
                          type="text"
                          className="form-control"
                          placeholder="Search here..."
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>


                      <div className="col-md-2 mb-2 pt-2 " >
                        <label
                          htmlFor="statusSelect"
                          className="form-label fw-bold"
                        >
                          Active / Inactive
                        </label>
                        <select
                          id="statusSelect"
                          className="form-select"
                          value={getActiveInactive}
                          onChange={(e) => setActiveInactive(e.target.value)}
                        >
                          <option value="all">All</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>


                      {/* <div className="col-md-3 mb-2">
                        <label className="form-label fw-bold d-block">
                          Filters
                        </label>
                        <div className="dropdown">
                          <button
                            className="btn btn-primary dropdown-toggle w-100"
                            type="button"
                            id="filterDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Select Filters
                          </button>

                          <ul
                            className="dropdown-menu w-100"
                            aria-labelledby="filterDropdown"
                          >
                            <li>
                              <label className="dropdown-item">
                                <input
                                  type="checkbox"
                                  checked={isAllSelected}
                                  onChange={handleSelectAll}
                                  className="form-check-input me-2"
                                />
                                Select All
                              </label>
                            </li>
                            {[
                              "EveryTransaction",
                              "FixedPerClient",
                              "FundAdd",
                              "NetTransactionPercent",
                            ].map((filter) => (
                              <li key={filter}>
                                <label className="dropdown-item">
                                  <input
                                    type="checkbox"
                                    value={filter}
                                    checked={selectedFilters.includes(filter)}
                                    onChange={handleFilterChange}
                                    className="form-check-input me-2"
                                  />
                                  {filter.replace(/([A-Z])/g, " $1").trim()}
                                </label>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div> */}
                    </div>

                    <Table
                      columns={columns}
                      data={data}
                      page={page}
                      totalPages={totalPages}
                      initialRowsPerPage={rowsPerPage}
                      onPageChange={handlePageChange}
                      onRowsPerPageChange={handleRowsPerPageChange}
                    />



                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin;
